import {gsap} from "gsap";

const heroBlocks = () => {

    const blocks = gsap.utils.toArray('.c-v4-homepage-hero__block' );
    const content = document.querySelector('.c-v4-homepage-hero--main-content');

    const timeline = gsap.timeline({
        paused: true
    });
    timeline.set(blocks, {
        autoAlpha: 0,
        y: 75,
    })
    timeline.set(content, {
        autoAlpha: 0,
        y: 50,
    })
    timeline.to( blocks, {
        autoAlpha: 1,
        y: 0,
        duration: 1.5,
        ease: 'power2.inOut',
        stagger: {
            each: 0.5,
        }
    })
    timeline.to( content, {
        autoAlpha: 1,
        y: 0,
        duration: 1.5,
        ease: 'power2.inOut'
    }, '-=0.75')

    let mm = gsap.matchMedia();

    mm.add("(min-width: 576px)", () => {
        timeline.seek(0);
        timeline.play();
    })

}

const init = () => {
    heroBlocks();
}

window.addEventListener('DOMContentLoaded', () => {
    init();
})